import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './styles/globals.css';
import { RootLayout } from './routes/layout';
import { HomePage } from './routes/home';
import { ShopPage } from './routes/shop';
import { ProfilePage } from './routes/profile';
import { RulesPage } from './routes/rules';
import { WikiPage } from './routes/wiki';
import { WikiArticlePage } from './routes/wiki-article';
import { ApplicationsPage } from './routes/applications';
import { TeamPage } from './routes/team';
import { LoginPage } from './routes/login';
import { AdminLayout } from './routes/admin/layout';
import { AdminDashboard } from './routes/admin/dashboard';
import { AdminProducts } from './routes/admin/products';
import { AdminServers } from './routes/admin/servers';
import { AdminUsers } from './routes/admin/users';
import { AdminTransactions } from './routes/admin/transactions';
import { AdminDeliveries } from './routes/admin/deliveries';
import { AdminTeam } from './routes/admin/team';
import { AdminFaq } from './routes/admin/faq';
import { AdminRules } from './routes/admin/rules';
import { AdminWiki } from './routes/admin/wiki';
import { AdminApplications } from './routes/admin/applications';
import { AdminPromos } from './routes/admin/promos';
import { AdminTemplates } from './routes/admin/templates';
import { ContactsPage } from './routes/contacts';
import { UserAgreementPage } from './routes/user-agreement';
import { PrivacyPolicyPage } from './routes/privacy-policy';
import { PaymentInfoPage } from './routes/payment-info';
import { AdminCategories } from './routes/admin/categories';
import { NotFoundPage } from './routes/not-found';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <NotFoundPage />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'shop', element: <ShopPage /> },
      { path: 'profile', element: <ProfilePage /> },
      { path: 'rules', element: <RulesPage /> },
      { path: 'wiki', element: <WikiPage /> },
      { path: 'wiki/:slug', element: <WikiArticlePage /> },
      { path: 'applications', element: <ApplicationsPage /> },
      { path: 'team', element: <TeamPage /> },
      { path: 'contacts', element: <ContactsPage /> },
      { path: 'user-agreement', element: <UserAgreementPage /> },
      { path: 'privacy-policy', element: <PrivacyPolicyPage /> },
      { path: 'payment-info', element: <PaymentInfoPage /> },
      { path: 'login', element: <LoginPage /> },
      {
        path: 'admin',
        element: <AdminLayout />,
        children: [
          { index: true, element: <AdminDashboard /> },
          { path: 'products', element: <AdminProducts /> },
          { path: 'categories', element: <AdminCategories /> },
          { path: 'servers', element: <AdminServers /> },
          { path: 'users', element: <AdminUsers /> },
          { path: 'transactions', element: <AdminTransactions /> },
          { path: 'deliveries', element: <AdminDeliveries /> },
          { path: 'team', element: <AdminTeam /> },
          { path: 'faq', element: <AdminFaq /> },
          { path: 'rules', element: <AdminRules /> },
          { path: 'wiki', element: <AdminWiki /> },
          { path: 'applications', element: <AdminApplications /> },
          { path: 'promos', element: <AdminPromos /> },
          { path: 'templates', element: <AdminTemplates /> },
        ],
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
